import { useEffect } from 'react';

const TawkToWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://embed.tawk.to/6859636cca05e2190bcf703b/1iueionup';
    script.async = true;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);

    // Optional cleanup if needed
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // Nothing to render
};

export default TawkToWidget;
